import React from 'react';

/** Standard 3-column form grid — pointage dialogs (3 fields per row on desktop). */
export const POINTAGE_FORM_GRID_CLASS = 'grid grid-cols-1 md:grid-cols-3 gap-4';

export function getPointageFormTabButtonClass(isLight, active) {
  return `inline-flex items-center gap-2 px-4 py-2.5 rounded-t-xl text-sm font-semibold transition-colors ${
    active
      ? (isLight
        ? 'bg-[#6e9b6e]/15 text-forest-900 border-b-2 border-[#6e9b6e] -mb-px'
        : 'bg-white/10 text-white border-b-2 border-blue-400 -mb-px')
      : (isLight
        ? 'text-gray-600 hover:text-gray-900 hover:bg-gray-100/80'
        : 'text-white/55 hover:text-white hover:bg-white/5')
  }`;
}

/**
 * Tabbed form shell for pointage CRUD modals — Products.js / ApprobationsCrudShell pattern.
 * One tab panel visible at a time (not accordion).
 */
export default function PointageFormModalShell({
  isLight,
  tabs,
  activeTab,
  onTabChange,
  formId,
  onSubmit,
  ariaLabel,
  children,
}) {
  const hasTabs = tabs?.length > 0;

  return (
    <div className="-m-6 flex flex-col min-h-[320px]">
      {hasTabs ? (
        <div className={`shrink-0 px-6 pt-3 border-b ${isLight ? 'border-gray-200' : 'border-white/10'}`}>
          <div className="flex flex-wrap gap-1" role="tablist" aria-label={ariaLabel}>
            {tabs.map((tab) => {
              const TabIcon = tab.icon;
              const active = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  aria-selected={active}
                  onClick={() => onTabChange(tab.id)}
                  className={getPointageFormTabButtonClass(isLight, active)}
                >
                  {TabIcon ? (
                    <TabIcon size={16} className={active ? (tab.iconClass || 'text-blue-400') : ''} />
                  ) : null}
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
      <div className="overflow-y-auto p-6 flex-1 min-h-0">
        <form id={formId} onSubmit={onSubmit}>
          {children}
        </form>
      </div>
    </div>
  );
}
